import { StyleSheet, Font } from "@react-pdf/renderer";

// const root = getComputedStyle(document.body);

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxP.ttf",
    },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontWeight: "bold",
    },
  ],
});

Font.register({
  family: "Helvetica Neue",
  fonts: [
    {
      src: "https://fonts.cdnfonts.com/s/29136/HelveticaNeueBold.woff",
    },
    {
      src: "https://fonts.cdnfonts.com/s/29136/Helvetica45Light_22437.woff",
      fontWeight: 300,
    },
  ],
});

/**
 * Styles for the PDF file.
 */
const styles = StyleSheet.create({
  page: {
    border: "1px solid #707070",
    padding: "61px 65px",
    userSelect: "none",
    fontSize: "10px",
    lineHeight: "1.2",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    fontSize: "15px",
    lineHeight: "calc(1em + 5px)",
    textTransform: "uppercase",
    fontWeight: "bold",
    paddingBottom: "26px",
  },
  "content-header": {
    fontSize: "14px",
    lineHeight: "calc(1em + 4px)",
    color: "#2A3847",
    fontWeight: "900",
  },
  "sub-header": {
    display: "inline-block",
    fontWeight: "bold",
    lineHeight: "1.2",
    marginBottom: "0",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "4px",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    // gap: "8px",
    padding: "8px 0 16px",
    listStyle: "none",
    lineHeight: "1.2",
  },
  "item-container": {
    display: "flex",
    flexDirection: "row",
  },
  "list-item": {
    width: "25%",
    marginBottom: "8px",
  },
  light: {
    fontWeight: 300,
  },
});

export default styles;
